import { GAME_CONSTANTS } from '../constants';

// Constants
export const QUEST_DURATION = GAME_CONSTANTS.QUEST_DURATION;

// Format time remaining as HH:MM:SS
export const formatTime = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

// Calculate progress percentage based on time remaining
export const calculateProgress = (timeRemaining: number, questStarted: boolean): number => {
  if (!questStarted) return 0;
  const elapsed = QUEST_DURATION - timeRemaining;
  return Math.min(100, Math.max(0, (elapsed / QUEST_DURATION) * 100));
};

// Reset quest timer to full duration
export const resetQuestTimer = (): number => QUEST_DURATION; 